// @ts-nocheck
import React from "react";
import rewardPointsStarIcon from "../../assets/reward-points-golden-star.svg"
import { ReactComponent as RewardRedeemGiftIcon } from "../../assets/reward-redeem-gift-icon.svg";
import NoPermissionComponent from "modules/kudos-user/component/NoPermissionComponent";
import { Button, Spin } from "antd";

const RewardSystemRedeemView = (props) => {
  const {
    loading,
    permission,
    totalPoints,
    rewardList,
    redeemReward
  } = props;

  return (
    <Spin spinning={loading}>
      {
        permission && rewardList.length > 0 ?
          <div className="overview-view">
            <div className="reward-redeem-container">
              <div className="reward-redeem-status">
                You have <span className="reward-redeem-status-points">{totalPoints} points</span> available to redeem
              </div>
              <div className="reward-redeem-grid">
                {rewardList.map(({ id, title, pointsNeeded, status }, i) => (
                  <div className={`reward-redeem-card 
                    ${status === "eligible"
                      ? " reward-redeem-card-active"
                      : status !== "not_eligible"
                        ? "reward-redeem-card-redeemed"
                        : ""
                    }
                  `} key={i}>
                    {/* <div className="redeemed-chip"><img src={rewardCompletedCheckIcon} alt="" />Redeemed</div> */}
                    <div className={`reward-redeem-card-icon
                      ${status === "eligible"
                        ? " reward-redeem-card-icon-active"
                        : status !== "not_eligible"
                          ? "reward-redeem-card-icon-redeemed"
                          : ""
                      }`}>
                      <RewardRedeemGiftIcon style={{ color: status === "eligible" ? '#4CCB1F' : status !== "not_eligible" ? "#0DD671" : "#7a7e8a" }} />
                    </div>
                    <div className={`reward-redeem-card-title ${status === "not_eligible" ? "unavailable-rewards" : ""}`}>{title}</div>
                    <div className={`reward-redeem-card-points ${status === "not_eligible" ? "unavailable-rewards" : ""}`}>
                      <img src={rewardPointsStarIcon} alt="" />
                      {pointsNeeded} points
                    </div>
                    {status === "not_eligible" ? (
                      <div className="reward-redeem-card-btn unavailable-rewards">
                        Need {Number(pointsNeeded) - Number(totalPoints)} more points
                      </div>
                    )
                      : status === "eligible"
                        ? <Button className="reward-redeem-card-btn active" onClick={() => { redeemReward(id, pointsNeeded) }}>Redeem Now</Button>
                        : <Button className="reward-redeem-card-btn redeemed-rewards" disabled>Redeemed</Button>
                    }
                  </div>
                ))}
              </div>
            </div>
          </div>
          : !loading && permission && <div className="no-activities-container">
            No Rewards Available
          </div>
      }
      {
        !loading && !permission && (
          <NoPermissionComponent />
        )
      }
    </Spin>
  )
}

export default RewardSystemRedeemView;